export const formReceitaBlank = {
  cod_receita: null,
  des_receita: '',
  flg_gluten: false,
  des_formula: '',
};
